module.exports = __webpack_public_path__ + "HelveticaBold.55ed3e42368494fe888a.woff2";


//////////////////
// WEBPACK FOOTER
// /var/www/minha-dinamica-cliente/src/app/@theme/fontes/Helvetica/HelveticaBold.woff2
// module id = ../../../../../src/app/@theme/fontes/Helvetica/HelveticaBold.woff2
// module chunks = styles